module.exports = ".input-group-addon, .form-control {\n  font-size: 16px;\n  height: 44px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login/login.component.css
// module id = ./src/app/components/login/login.component.css
// module chunks = main